import React, { useRef, useState, useEffect } from 'react';
import './sarthi.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
function SarthPage() {
const challenges = [
  { id: 1, icon: "/assets/navi-stick/sarthi-icons/network-icon.svg", title: "Poor mobile network", height: "22px" },
  { id: 2, icon: "/assets/navi-stick/sarthi-icons/unpredictable-icon.svg", title: "Unpredictable weather", height: "35px" },
  { id: 3, icon: "/assets/navi-stick/sarthi-icons/emergencies-icon.svg", title: "Emergencies anytime", height: "30px" },
  { id: 4, icon: "/assets/navi-stick/sarthi-icons/steep-icon.svg", title: "Steep paths", height: "30px" },
];

const bookingSarthi = [
  { id: 1, icon: "/assets/navi-stick/sarthi-icons/check-icon.svg", title: "Book in Advance", description: "Schedule your guide before you arrive for a hassle-free experience." },
  { id: 2, icon: "/assets/navi-stick/sarthi-icons/check-icon.svg", title: "Find Instantly", description: "Search for available guides near you, on the go." },
  { id: 3, icon: "/assets/navi-stick/sarthi-icons/check-icon.svg", title: "Verified & Trusted", description: "All guides are verified, experienced and background checked." },
  { id: 4, icon: "/assets/navi-stick/sarthi-icons/check-icon.svg", title: "Choose Your Guide", description: "View profiles, languages, ratings, experience and availability." },
  { id: 5, icon: "/assets/navi-stick/sarthi-icons/check-icon.svg", title: "Easy & Secure Booking", description: "Simple booking flow with secure payments through the app." },
  { id: 6, icon: "/assets/navi-stick/sarthi-icons/check-icon.svg", title: "Emergency Support", description: "One tap to reach help — anytime, anywhere on the route." },
];

const families = [
  { id: 1, icon: "/assets/navi-stick/sarthi-icons/parents-icon.svg", title: "Parents", description: "Extra care and personal attention.", height: "30px" },
  { id: 2, icon: "/assets/navi-stick/sarthi-icons/grandparents-icon.svg", title: "Grandparents", description: "Support, patience and assistance throughout.", height: "30px" },
  { id: 3, icon: "/assets/navi-stick/sarthi-icons/children-icon.svg", title: "Children", description: "Safe guidance and help whenever needed.", height: "25px" },
  { id: 4, icon: "/assets/navi-stick/sarthi-icons/entire-family-icon.svg", title: "Entire Family", description: "You enjoy the yatra, we take care of the rest.", height: "35px" },
];

const assiatanceData = [
  { id: 1, title: "Route Guidance", description: "Best routes, shortcuts and important checkpoints.", icon: "/assets/navi-stick/sarthi-icons/hand-icon.svg" },
  { id: 2, title: "Temple Information", description: "Rituals, timings and important facilities at the shrine.", icon: "/assets/navi-stick/sarthi-icons/temple-information.svg" },
  { id: 3, title: "Elderly Assistance", description: "Personal care and extra support at every step.", icon: "/assets/navi-stick/sarthi-icons/elderly-icon.svg" },
  { id: 4, title: "Food & Rest", description: "Best food, clean washrooms and rest points.", icon: "/assets/navi-stick/sarthi-icons/rest-icon.svg" },
  { id: 5, title: "Local Support", description: "Language help, temple info and local know-how.", icon: "/assets/navi-stick/sarthi-icons/suport-icon.svg" },
  { id: 6, title: "Emergency Support", description: "Always reachable, ready to help when it matters.", icon: "/assets/navi-stick/sarthi-icons/emergency-icon.svg" },
];

const firstData = [
  { id: 1, icon: "/assets/navi-stick/sarthi-icons/not-sure-icon.svg", title: "Not sure where to begin?", height: "40px" },
  { id: 2, icon: "/assets/navi-stick/sarthi-icons/stay-icon.svg", title: "Not sure where to stay?", height: "30px" },
  { id: 3, icon: "/assets/navi-stick/sarthi-icons/plan-icon.svg", title: "Not sure how to plan your journey?", height: "25px" },
];

const saarthiData = [
  { id: 1, icon: "/assets/navi-stick/sarthi-icons/situation-icon.svg", title: "Helps you in every possible situation.", height: "45px" },
  { id: 2, icon: "/assets/navi-stick/sarthi-icons/hand-icon.svg", title: "Knows the routes like the back of his hand.", height: "45px" },
  { id: 3, icon: "/assets/navi-stick/sarthi-icons/solution-icon.svg", title: "Answers your questions and shares knowledge.", height: "40px" },
  { id: 4, icon: "/assets/navi-stick/sarthi-icons/shield-icon.svg", title: "Ensures a safe, comfortable and worry-free yatra.", height: "45px" },
];

const featureData = [
  { id: 1, title: "CONVENIENT", subtitle: "Anytime, anywhere" },
  { id: 2, title: "RELIABLE", subtitle: "Verified guides you can trust" },
  { id: 3, title: "SUPPORTIVE", subtitle: "With you at every step" },
  { id: 4, title: "HIGHLY RATED", subtitle: "Loved by thousands of pilgrims" },
];
return (
<>
<Box className="hero-banner sarthiBanner">
   <Container maxWidth="lg">
      <Grid
         container
         alignItems="center"
         justifyContent="center"
         >
         <Grid item size={{ md: 12 }}>
         <div className="hero-content">
            <span className="badge-tag">Coming Soon</span>
            <h1>MandirWiki <span>Saarthi Service</span></h1>
            <p>
               Your trusted companion for temple visits, treks <br /> and pilgrimages trained, verified and by your <br /> side every step of the way.
            </p>
            <div className="hero-buttons">
               <a href="/contact-us" className="reserve-btn text-decoration-none">
               Booking guide
               </a>
               <a href="#thirdBanner" className="learn-btn text-decoration-none">
               How it works
               </a>
            </div>
         </div>
      </Grid>
      </Grid>
   </Container>
</Box>
<section className="first-section pb-0">
   <Container maxWidth="md">
      <Grid container spacing={2} className="mt-3" alignItems="center">
         <Grid size={{ lg: 5, md:5, sm:12, xs:12  }}>
         <div className="help-content">
            <h2>First Visit to Vaishno Devi?</h2>
            <p>
               You are not alone. We are here to make your yatra smooth,
               safe and worry-free from the very first step.
            </p>
         </div>
      </Grid>
      <Grid size={{ lg: 7, md:7, sm:12, xs:12 }}>
      <div className="help-cards">
         {firstData.map((item) => (
         <div className="help-card" key={item.id}>
            <div className="card-icon">
               <img src={item.icon} alt={item.title} height={item.height} />
            </div>
            <div className="card-content">
               {item.title}
            </div>
         </div>
         ))}
      </div>
      </Grid>
      </Grid>
   </Container>
</section>
<section className="challenge-section pb-0">
   <Container maxWidth="md">
      <div className="common-heading text-center">
         <span className="common-subtitle">Challenges on the way</span>
         <h2 className="common-title">
            <span className="highlight"><strong className="lightSuccess">Faith takes you forward.</strong> <br /> We help you stay safe.</span>
            {/* <span className="normal">We help you stay safe.</span> */}
         </h2>
         <p className='mt-3'>Steep paths, unpredictable weather, poor network, crowded shrines every pilgrim <br /> needs more than just a walking stick.</p>
      </div>
      <Grid container spacing={2} className="mt-0" alignItems="center" justifyContent="center">
         {challenges.map((item) => (
         <Grid  size={{ lg: 6, md: 6, sm: 12, xs: 12 }} key={item.id}>
         <div className="challenge-card">
            <div className="icon">
               <img src={item.icon} alt={item.title} height={item.height} />
            </div>
            <h5>{item.title}</h5>
         </div>
      </Grid>
      ))}
      </Grid>
   </Container>
</section>


<section className="saarthi-section pb-0">
   <Container maxWidth="md">
      <div className="common-heading text-center">
         <span className="common-subtitle">Meet Your</span>
         <h2 className="common-title">
            <span className="highlight">Saarthi</span>
            {/* <span className="normal">We help you stay safe.</span> */}
         </h2>
         <p className='mt-3'>A trained local companion who helps you throughout your pilgrimage so you can <br /> focus on devotion instead of logistics.</p>
      </div>
      <div className="saarthi-box">
      <Grid container spacing={4} className="mt-3" alignItems="center" justifyContent="center">
          
         {saarthiData.map((item) => (

                            <Grid size={{ lg: 3 }} key={item.id}>

                                <div className="saarthi-card">

                                    <div className="icon">
                                        <img src={item.icon} alt={item.title} height={item.height} />
                                    </div>

                                    <h5>{item.title}</h5>

                                </div>

                            </Grid>

                        ))}

      </Grid>
      </div>
   </Container>
</section>

<section className="help-section pb-0">
   <Container maxWidth="md">
      <div className="common-heading text-center">
         <span className="common-subtitle">What your guide brings</span>
         <h2 className="common-title">
            <span className="highlight">Assistance every step of <br /> the way</span>
            {/* <span className="normal">We help you stay safe.</span> */}
         </h2>
      </div>
      <Grid container spacing={2} className="mt-3">
         {assiatanceData.map((item) => (
         <Grid
         key={item.id}
         size={{
         xs: 12,
         sm: 6,
         md: 4,
         }}
         >
         <div className="help-card">
            <div className="icon-circle">
               <img src={item.icon} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
         </div>
      </Grid>
      ))}
      </Grid>
   </Container>
</section>



<section className="challenge-section pb-0">
   <Container maxWidth="md">
      <div className="common-heading text-center">
         <span className="common-subtitle">Perfect for</span>
         <h2 className="common-title">
            <span className="highlight">Families</span>
            {/* <span className="normal">We help you stay safe.</span> */}
         </h2>
         <p>Because every family deserves a smooth and memorable Yatra.</p>
      </div>
      <Grid container spacing={2} className="mt-3" justifyContent="center">
         {families.map((item) => (
         <Grid  size={{ lg: 6, md: 6, sm: 12, xs: 12 }} key={item.id}>
         <div className="challenge-card familyCard">
            <div className="icon">
               <img src={item.icon} alt={item.title} height={item.height} />
            </div>
            <div>
            <h5>{item.title}</h5>
            <p>{item.description}</p>
            </div>
         </div>
         
      </Grid>
      ))}

      <Grid  size={{ md: 12, lg:12 }}>
         <div className="blessed-section">
               <div className="blessed-banner">
                     <h2>
                        WHEN YOUR FAMILY IS HAPPY, THE YATRA BECOMES TRULY
                        <span> BLESSED</span>
                     </h2>
               </div>
         </div>
      </Grid>
      </Grid>
   </Container>
</section>


<section className="challenge-section ">
  <Container maxWidth="md">

    <div className="common-heading text-center">
      <span className="common-subtitle">
        Book in advance or instantly
      </span>

      <h2 className="common-title">
        <span className="highlight">
          Book your <strong className='lightSuccess'>Saarthi</strong>
        </span>
      </h2>

      <p>
        Plan ahead and book in advance, or find an available guide instantly
        through the <br /> MandirWiki app.
      </p>
    </div>

    {/* Challenge Cards */}
    <Grid
      container
      spacing={2}
      className="mt-3"
      justifyContent="center"
    >
      {bookingSarthi.map((item) => (
        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }} key={item.id}>
          <div className="challenge-card sarthiBook align-items-start">
            <div className="icon">
              <img src={item.icon} alt={item.title} height="15" />
            </div>

            <div>
              <h5>{item.title}</h5>
              <p>{item.description}</p>
            </div>
          </div>
        </Grid>
      ))}
    </Grid>

    {/* Feature Strip */}
    <div className="feature-strip mt-5">
      <div className="feature-wrapper">

        <Grid container>
          {featureData.map((item, index) => (
            <Grid size={{ xs: 12, md: 6, lg: 3 }} key={item.id}>
              <div
                className={`feature-item ${
                  index !== featureData.length - 1 ? "border-right" : ""
                }`}
              >
                <h4>{item.title}</h4>
                <p>{item.subtitle}</p>
              </div>
            </Grid>
          ))}
        </Grid>

      </div>
    </div>

  </Container>
</section>


<section className="notify-section">
      <Container>

        <div className="notify-wrapper">

          <div className="stars">
            {[...Array(5)].map((_, index) => (
              <i class="fa fa-star" key={index} ></i>
            ))}
          </div>

          <h2>
            <span className="white-text">
              YOU FOCUS ON DEVOTION.
            </span>

            <span className="yellow-text">
              WE'LL HANDLE THE JOURNEY.
            </span>
          </h2>

          <p>
            Reserve your verified saarthi today and step into your
            pilgrimage with peace of mind.
          </p>

          <form className="notify-form">

            <input
              type="tel"
              placeholder="YOUR PHONE NUMBER"
            />

            <button type="submit">
              NOTIFY ME
            </button>

          </form>

        </div>

      </Container>
    </section>

</>
);
}
export default SarthPage;